import React, { useState, useEffect } from "react";
import { ChevronDown, ChevronUp, ArrowLeft, FileText } from "lucide-react";

const articles = [
  {
    id: 1,
    title: "Art. 1 – Definizioni",
    content: `1.1 Nelle presenti Condizioni Generali di Contratto i seguenti termini hanno il significato qui di seguito specificato:

a) per "contratto di vendita on line" si intende il contratto a distanza stipulato tra il Venditore ed un Acquirente consumatore finale, attraverso un sistema di vendita organizzato dal Venditore, che utilizza la tecnologia di comunicazione a distanza denominata internet;

b) l'espressione "Fornitore" si riferisce a CAF DIPENDENTI E PENSIONATI AIC SRL, con sede in 42017 – Novellara (RE), Via Andrea Costa n. 15, C.F. 02920400351, parte del presente contratto, che provvede alla gestione del Sito e vende direttamente agli utenti (Acquirenti) i Servizi indicati al punto che segue;

c) l'espressione "Servizi" si riferisce esclusivamente ai servizi presenti nei cataloghi elettronici del Sito;

d) l'espressione "Acquirente" si riferisce al consumatore finale-cliente autorizzato ad operare sul Sito al fine di acquistare i servizi, secondo le modalità indicate nelle presenti condizioni generali;

e) per "Consumatore" s'intende la persona fisica che acquista beni e servizi per scopi non riferibili, né direttamente né mediatamente, all'attività professionale eventualmente svolta;

f) l'espressione "Parti" si riferisce al Venditore e all'Acquirente congiuntamente intesi;

g) l'espressione "Sito" si riferisce al sito internet corrispondente all'indirizzo https://cafpraticheonline.it/ tramite il quale è possibile effettuare acquisti on line;

h) il termine "Corrispettivo" si riferisce al prezzo di vendita di ciascun servizio.`,
  },
  {
    id: 2,
    title: "Art. 2 – Oggetto del contratto",
    content: `2.1 Le presenti condizioni generali, messe nella disponibilità dell'Acquirente per la riproduzione e conservazione ai sensi dell'art. 12 del D.Lgs. 9 aprile 2003, n. 70, hanno per oggetto l'acquisto di servizi effettuato a distanza e per mezzo di rete telematica tramite il Sito internet appartenente al Venditore.

2.2 Con il presente contratto, rispettivamente, il Venditore vende e l'Acquirente acquista a distanza i servizi di seguito indicati.

2.3 I servizi oggetto del presente contratto sono tutti i prodotti/servizi scelti dall'Acquirente seguendo le procedure di acquisto on line indicate nel Sito.

2.4 I servizi attualmente offerti comprendono:

Pratiche fiscali e reddituali: ISEE Ordinario, ISEE Universitario, ISEE Socio Sanitario, ISEE Minorenni, Integrazione ISEE, Modello Redditi Persone Fisiche senza P.IVA, Modello Redditi P.IVA Forfettaria, Integrazione Modello Redditi PF.

Prestazioni INPS – Disoccupazione e lavoro: Disoccupazione NASPI, Anticipo NASPI, NASPI-Com, Dis-Coll, Disoccupazione Agricola, Dimissioni Volontarie, Revoca Dimissioni Volontarie, Dimissioni per Giusta Causa.

Prestazioni INPS – Famiglia e maternità: Assegno Unico e Universale, Aggiornamento Assegno Unico e Universale, Assegno di Maternità, Maternità Obbligatoria Post Parto, Indennità di Maternità Obbligatoria Dipendenti, Indennità di Maternità Obbligatoria Gestione Separata, Indennità di Maternità Obbligatoria Autonomi, Maternità Anticipata Dipendenti, Maternità Anticipata Gestione Separata, Congedo Parentale Dipendenti, Congedo Parentale Gestione Separata, Congedo Parentale Autonomi, Bonus Asilo Nido, Integrazione Bonus Asilo Nido, Assegno Nucleo Familiare Lavoratori Dipendenti, Assegno Nucleo Familiare Lavoratori Domestici.

Prestazioni INPS – Previdenza e invalidità: Estratto Conto Previdenziale, Estratto Conto Certificato e Calcolo Pensione, Pensione Indiretta, Invalidità Civile, Permessi 104/92 per assistenza ai familiari disabili, Assegno di Inclusione.

Pratiche immigrazione: Ricongiungimento Familiare, Rinnovo Permesso di Soggiorno per Lavoro Subordinato, Rinnovo Permesso di Soggiorno per Motivi Familiari, Rinnovo Permesso di Soggiorno per Lavoro Autonomo, Rilascio Permesso di Soggiorno per Soggiornanti di Lungo Periodo, Aggiornamento Permesso di Soggiorno, Cittadinanza Italiana per Residenza, Cittadinanza Italiana per Matrimonio, Test di Conoscenza della Lingua Italiana A2.

Colf e badanti: Assunzione Colf e Badanti, Lettera di Assunzione Colf e Badanti, Busta Paga Colf e Badanti, MAV Trimestrale Colf e Badanti, Variazione Colf e Badanti, Cessazione Colf e Badanti.

Altri servizi: Comunicazione INPS, Rateazione Cartelle Agenzia delle Entrate.

Il Venditore si riserva di aggiornare, aggiungere o rimuovere servizi dal catalogo in qualsiasi momento.

2.5 Il Venditore si impegna a fornire tutti i servizi indicati dietro il pagamento di un corrispettivo di cui all'art. 4 del presente contratto.`,
  },
  {
    id: 3,
    title: "Art. 3 – Accettazione delle condizioni di vendita",
    content: `3.1 Le presenti condizioni generali sono valide dal giorno di conclusione del presente contratto e potranno essere aggiornate, integrate o modificate in qualsiasi momento dal Venditore, il quale provvederà a darne comunicazione tramite le pagine del Sito; tali aggiornamenti avranno efficacia per i futuri acquisti.

3.2 Tutti gli ordini di acquisto saranno inoltrati dall'Acquirente al Venditore, previa registrazione al sito e digitazione di credenziali di accesso in un'area riservata tramite protocollo sicuro (https), e quindi attraverso il completamento della procedura di acquisto indicata.

3.3 Le presenti condizioni generali di vendita devono essere esaminate "on line" dall'Acquirente prima del completamento della procedura di acquisto. L'inoltro della conferma d'ordine d'acquisto implica totale conoscenza delle stesse e loro integrale accettazione.

3.4 L'Acquirente, inviando telematicamente la conferma del proprio ordine d'acquisto, accetta incondizionatamente e si obbliga ad osservare, nei suoi rapporti con il Venditore, le condizioni generali e di pagamento di seguito illustrate, prendendo atto che il Venditore non si ritiene vincolato a condizioni diverse se non preventivamente concordate per iscritto.

3.5 Le operazioni di vendita sono regolate per il consumatore dalle disposizioni di cui al D.Lgs. 6 settembre 2005, n. 206, mentre la tutela della riservatezza è sottoposta alla disciplina del Regolamento UE 2016/679 (GDPR) e al D.Lgs. 10 agosto 2018, n. 101.

3.6 L'accettazione delle condizioni di vendita va manifestata tramite l'esatta compilazione di tutte le sezioni del form elettronico, selezionando le caselle ACCETTAZIONE CONDIZIONI DI VENDITA e INFORMATIVA PRIVACY.`,
  },
  {
    id: 4,
    title: "Art. 4 – Modalità d'acquisto e prezzi di vendita",
    content: `4.1 I servizi, i prezzi e le condizioni di vendita presenti sul Sito – nei limiti della loro disponibilità – sono espressi in euro e costituiscono per il consumatore offerta al pubblico.

4.2 I prezzi di vendita sono al netto dell'IVA e di ogni altra imposta. Il costo totale viene reso noto al cliente prima della conferma dell'acquisto.

4.3 Il prezzo del servizio indicato sul Sito ha valore definitivo, salvo il caso in cui – per situazioni eccezionali – il Venditore consideri opportuno sottoporre il prezzo a revisione. Nei casi eccezionali di revisione del prezzo, le Parti si impegnano a svolgere la rinegoziazione attraverso uno scambio di e-mail, secondo correttezza e buona fede.

4.4 Il ricevimento dell'ordine impegna il Venditore secondo il modello dell'offerta al pubblico ex art. 1336 c.c. All'atto della ricezione dell'ordine, il sistema invierà automaticamente una mail di riscontro riepilogativa dell'ordine ricevuto, quale formale accettazione dello stesso.

4.5 L'Acquirente dichiara espressamente di compiere l'acquisto dei servizi per fini estranei all'attività commerciale o professionale eventualmente esercitata.`,
  },
  {
    id: 5,
    title: "Art. 5 – Conclusione del contratto",
    content: `5.1 Il contratto stipulato tramite il Sito si intende concluso nel momento in cui l'Acquirente accetta l'offerta al pubblico ex art. 1336 c.c. del Venditore ed invia l'ordine al termine della procedura di acquisto. In seguito, il Venditore invia una e-mail automatica riepilogativa dell'ordine, attraverso la quale informa l'Acquirente circa le modalità di erogazione dei servizi. Il contratto si conclude nel luogo in cui è situata la sede legale del Venditore.`,
  },
  {
    id: 6,
    title: "Art. 6 – Modalità di erogazione dei Servizi",
    content: `6.1 Il Fornitore provvederà ad erogare i Servizi acquistati con le modalità indicate sul Sito al momento dell'offerta del Servizio e confermate a mezzo e-mail.

6.2 I Servizi offerti dal Fornitore sono indicati all'interno del Sito.

6.2-bis Numerosi servizi offerti da CAF DIPENDENTI E PENSIONATI AIC SRL prevedono l'intervento obbligatorio di enti e istituzioni terze, quali INPS, Agenzia delle Entrate, Ministero dell'Interno, Questure, Prefetture, Comuni e altri enti pubblici. Per tali servizi, i tempi di lavorazione e l'esito finale della pratica dipendono esclusivamente dalle tempistiche e dalle decisioni di detti enti terzi e non sono in alcun modo imputabili al Venditore. CAF DIPENDENTI E PENSIONATI AIC SRL agisce in qualità di intermediario/facilitatore nella predisposizione e trasmissione delle pratiche e non può garantire l'esito delle stesse.

6.3 Ciascun Servizio acquistato dal Cliente prevede le seguenti fasi di elaborazione:
• Da Elaborare: il Fornitore ha ricevuto la richiesta ma non ha ancora iniziato ad elaborarla;
• In Elaborazione: il Fornitore sta elaborando la pratica;
• Info Mancante: manca un documento o informazione che il Cliente dovrà fornire;
• Completo: servizio completato e consegnato.

6.4 Una volta che il Servizio raggiungerà lo status "Completo", il Venditore provvederà a consegnare all'Acquirente le ricevute mediante caricamento nell'area riservata sul Sito e contestuale invio di e-mail.

6.5 Qualora per il servizio erogato vi sia la necessità di consegnare documentazione cartacea, il Venditore provvederà a recapitarla all'indirizzo indicato dall'Acquirente, mediante corrieri e/o spedizionieri di fiducia, entro 10 giorni lavorativi dalla conferma dell'ordine.

6.6 Ove l'Acquirente sia assente, verrà lasciato un avviso con le indicazioni necessarie per contattare il corriere al fine di concordare le modalità di consegna.

6.7 Nessuna responsabilità potrà essere attribuita al Venditore per ritardata o mancata consegna imputabile a cause di forza maggiore o caso fortuito.

6.8 All'atto del ricevimento, l'Acquirente è tenuto a verificare la conformità di quanto consegnato con l'ordine effettuato, fermo restando il diritto di recesso previsto all'art. 9.`,
  },
  {
    id: 7,
    title: "Art. 7 – Responsabilità",
    content: `7.1 Il Venditore non assume alcuna responsabilità per il ritardo o la mancata consegna del servizio imputabile a cause di forza maggiore quali incidenti, esplosioni, incendi, scioperi e/o serrate, terremoti, alluvioni, pandemie ed altri similari eventi che impedissero, in tutto o in parte, di dare esecuzione nei tempi concordati al contratto.

7.2 Il Venditore non sarà responsabile nei confronti di alcuna parte o di terzi in merito a danni, perdite e costi subiti a seguito della mancata esecuzione del contratto per le cause sopra citate, avendo il consumatore diritto soltanto alla restituzione del prezzo eventualmente corrisposto.

7.3 Il Venditore garantisce che i Servizi presenti all'interno dei cataloghi elettronici sono liberamente acquistabili. In ogni caso si applicano le norme del codice civile italiano in tema di compravendita.

7.4 In relazione ai servizi che comportano l'interazione con enti pubblici o istituzionali (INPS, Agenzia delle Entrate, Ministero dell'Interno, Questure, Prefetture, ecc.), il Venditore declina ogni responsabilità per: (a) ritardi nell'elaborazione delle pratiche imputabili ai suddetti enti; (b) esiti negativi, rigetti o dinieghi delle domande presentate; (c) modifiche normative o procedurali intervenute successivamente all'acquisto del servizio. La prestazione di CAF DIPENDENTI E PENSIONATI AIC SRL si intende correttamente eseguita con la predisposizione e la trasmissione della pratica all'ente competente, indipendentemente dall'esito della stessa.

7.5 Il Venditore non è responsabile di eventuali conseguenze derivanti da informazioni inesatte, incomplete o false fornite dall'Acquirente in sede di predisposizione della pratica. L'Acquirente è il solo responsabile della veridicità e completezza dei dati e documenti forniti.`,
  },
  {
    id: 8,
    title: "Art. 8 – Obblighi dell'Acquirente",
    content: `8.1 L'Acquirente si impegna e si obbliga, una volta conclusa la procedura d'acquisto, a provvedere alla stampa e alla conservazione delle presenti condizioni generali, nonché delle specifiche del servizio oggetto dell'acquisto, al fine di soddisfare integralmente le condizioni di cui al D.Lgs. 6 settembre 2005, n. 206.

8.2 È fatto severo divieto all'Acquirente di inserire dati falsi, inventati o di fantasia nella procedura di registrazione e nei form elettronici relativi ai dati necessari per l'erogazione del Servizio. I dati anagrafici e la e-mail devono essere esclusivamente i propri reali dati personali. L'Acquirente si assume la piena responsabilità circa l'esattezza e la veridicità dei dati immessi.

8.3 È espressamente vietato effettuare doppie registrazioni corrispondenti ad una sola persona o inserire dati di terze persone. Il Venditore si riserva di perseguire legalmente ogni violazione ed abuso.

8.4 L'Acquirente manleva il Venditore da ogni responsabilità derivante dall'emissione di documenti fiscali errati a causa di errori relativi ai dati forniti dall'Acquirente, essendone quest'ultimo l'unico responsabile del corretto inserimento.`,
  },
  {
    id: 9,
    title: "Art. 9 – Diritto di recesso",
    content: `9.1 A norma degli artt. 64 e 67 del D.Lgs. 6 settembre 2005, n. 206, l'Acquirente può esercitare il diritto di recesso dal Servizio prima che questo sia stato fornito, anche solo in parte, ricevendo in tale caso il rimborso delle somme a suo tempo corrisposte tramite il Sito.

9.2 L'Acquirente ha diritto di recedere dal contratto stipulato, senza alcuna penalità e senza specificarne il motivo, entro il termine di 14 giorni decorrenti dal giorno della conclusione del contratto.

9.3 Per esercitare il diritto di recesso l'Acquirente dovrà, entro il termine indicato al punto 9.2, inviare comunicazione scritta al seguente indirizzo: CAF DIPENDENTI E PENSIONATI AIC SRL, Via Andrea Costa n. 15, 42017 Novellara (RE), oppure a mezzo e-mail all'indirizzo  cafpraticheonline@gmail.com.

9.4 Laddove l'esecuzione del Servizio da parte del Venditore sia iniziata prima dello scadere del termine di cui al punto 9.2, l'Acquirente potrà recedere dal contratto unicamente qualora la pratica connessa al servizio acquistato risulti ancora nello status "Da Elaborare". Qualora la pratica risulti in uno stato successivo (In Elaborazione, Info Mancante, Completo), l'Acquirente perderà il diritto di recesso e ogni diritto al rimborso del corrispettivo già versato.

9.4-bis Per i servizi che richiedono l'immediata trasmissione ad enti terzi (quali, a titolo esemplificativo, Busta Paga Colf e Badanti, MAV Trimestrale, Rinnovo Permesso di Soggiorno, pratiche INPS con scadenze prefissate), l'elaborazione si intende avviata nel momento stesso dell'accettazione dell'ordine da parte del Venditore. In tali casi il diritto di recesso potrà essere esercitato esclusivamente qualora la pratica non sia ancora stata trasmessa all'ente competente, come risultante dallo status "Da Elaborare" nell'area personale dell'Acquirente.

9.5 All'Acquirente che eserciti il diritto di recesso conformemente a quanto stabilito saranno rimborsate le somme già versate entro il termine di 15 giorni, e comunque non oltre 30 giorni a partire dalla data in cui il Venditore è venuto a conoscenza dell'esercizio del diritto di recesso.`,
  },
  {
    id: 10,
    title: "Art. 10 – Risoluzione del contratto",
    content: `10.1 Le parti convengono che il contratto si risolverà di diritto in seguito al verificarsi di uno dei seguenti inadempimenti:
• violazione degli obblighi di cui all'art. 4 (Modalità d'acquisto e prezzi di vendita);
• violazione degli obblighi di cui all'art. 7 (Responsabilità);
• violazione degli obblighi di cui all'art. 8 (Obblighi dell'Acquirente);
• violazione degli obblighi di cui all'art. 13 (Divieto di cessione).

10.2 Ai sensi dell'art. 1456 c.c., la parte che intenda avvalersi della risoluzione ne darà comunicazione alla controparte mediante invio di raccomandata a/r o e-mail certificata, indicando la motivazione. Gli effetti della risoluzione decorrono dalla data di ricezione della comunicazione e l'Acquirente avrà diritto esclusivamente alla restituzione dell'eventuale somma già corrisposta.`,
  },
  {
    id: 11,
    title: "Art. 11 – Comunicazioni",
    content: `11.1 Fatti salvi i casi espressamente indicati o stabiliti da obblighi di legge, le comunicazioni tra il Venditore e l'Acquirente avranno luogo preferibilmente tramite messaggi e-mail ai rispettivi indirizzi elettronici, che entrambe le parti considerano valido mezzo di comunicazione.

11.2 Entrambe le parti potranno in qualsiasi momento cambiare il proprio indirizzo e-mail ai fini del presente articolo, purché ne diano tempestiva comunicazione all'altra parte.`,
  },
  {
    id: 12,
    title: "Art. 12 – Trattamento dei dati personali",
    content: `12.1 L'Acquirente dichiara espressamente di aver preso visione dell'informativa sul trattamento dei dati personali ai sensi dell'art. 13 del Regolamento UE 2016/679 (GDPR) e della "privacy policy" del Sito.

12.2 I diritti derivanti dalla normativa sulla privacy e gli obblighi di informativa da essa nascenti a carico del Venditore sono esaminati "on line" prima del completamento della procedura di acquisto. L'inoltro della conferma d'ordine implica totale conoscenza degli stessi.

12.3 Il Titolare della raccolta e del trattamento dei dati personali è CAF DIPENDENTI E PENSIONATI AIC SRL, con sede in 42017 – Novellara (RE), Via Andrea Costa n. 15. I diritti di cui all'art. 7 del GDPR sono esercitati con richiesta inviata all'indirizzo e-mail  cafpraticheonline@gmail.com.`,
  },
  {
    id: 13,
    title: "Art. 13 – Divieto di cessione",
    content: `13.1 Il contratto non è cedibile a terzi, a pena dell'immediata risoluzione dello stesso.`,
  },
  {
    id: 14,
    title: "Art. 14 – Giurisdizione e Foro competente",
    content: `14.1 Ogni controversia relativa all'applicazione, esecuzione, interpretazione e violazione dei contratti d'acquisto stipulati on line tramite il Sito web del Venditore è sottoposta alla giurisdizione italiana; le presenti condizioni generali si riportano, per quanto non espressamente previsto, al D.Lgs. 6 settembre 2005, n. 206 (Codice del Consumo).

14.2 In caso di controversie derivanti dal presente contratto, le parti si impegnano a cercare tra loro un equo e bonario componimento.

14.3 Qualora la controversia non sia stata risolta bonariamente, e comunque entro sei mesi dalla data del suo inizio, la stessa sarà portata alla cognizione esclusiva del Foro nel cui circondario ha il proprio domicilio l'Acquirente/Consumatore, ai sensi del D.Lgs. 206/2005.`,
  },
  {
    id: 15,
    title: "Art. 15 – Clausole finali",
    content: `15.1 Il presente contratto abroga e sostituisce ogni accordo, intesa, negoziazione, scritta od orale, intervenuta in precedenza tra le parti e concernente l'oggetto di questo contratto.`,
  },
  {
    id: 16,
    title: "Art. 16 – Legge applicabile e rinvio",
    content: `16.1 Il presente contratto è regolato dalla legge italiana.

16.2 Per quanto non espressamente disposto valgono le norme di legge applicabili ai rapporti e alle fattispecie previste nel presente contratto e, in ogni caso, le norme del Codice Civile e del D.Lgs. 6 settembre 2005, n. 206 (Codice del Consumo).`,
  },
];

const AccordionItem = ({ article, isOpen, onToggle }) => {
  return (
    <div
      style={{
        borderBottom: "1px solid rgba(242,194,49,0.2)",
        overflow: "hidden",
      }}
    >
      <button
        onClick={onToggle}
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "18px 24px",
          background: isOpen
            ? "linear-gradient(90deg, rgba(242,194,49,0.08), transparent)"
            : "transparent",
          border: "none",
          cursor: "pointer",
          textAlign: "left",
          transition: "background 0.3s ease",
        }}
      >
        <span
          style={{
            color: isOpen ? "#F2C231" : "#CBD5E1",
            fontWeight: isOpen ? "700" : "600",
            fontSize: "0.95rem",
            letterSpacing: "0.01em",
            transition: "color 0.3s ease",
          }}
        >
          {article.title}
        </span>
        <span style={{ color: "#F2C231", flexShrink: 0, marginLeft: "12px" }}>
          {isOpen ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
        </span>
      </button>

      <div
        style={{
          maxHeight: isOpen ? "2000px" : "0",
          overflow: "hidden",
          transition: "max-height 0.4s ease",
        }}
      >
        <div
          style={{
            padding: "4px 24px 24px 24px",
            color: "#94A3B8",
            fontSize: "0.875rem",
            lineHeight: "1.85",
            whiteSpace: "pre-wrap",
          }}
        >
          {article.content}
        </div>
      </div>
    </div>
  );
};

const TermsNConditions = () => {
  const [openArticle, setOpenArticle] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 50);
    return () => clearTimeout(timer);
  }, []);

  const handleToggle = (id) => {
    setOpenArticle(openArticle === id ? null : id);
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(160deg, #0F2030 0%, #182F40 50%, #1D3A50 100%)",
        fontFamily: "'Georgia', 'Times New Roman', serif",
      }}
    >
      

      {/* Hero header */}
      <div
        style={{
          padding: "64px 32px 48px",
          textAlign: "center",
          opacity: visible ? 1 : 0,
          transform: visible ? "translateY(0)" : "translateY(20px)",
          transition: "opacity 0.7s ease, transform 0.7s ease",
        }}
      >
        {/* Gold decorative line */}
        <div
          style={{
            width: "60px",
            height: "3px",
            background: "linear-gradient(90deg, #F2C231, #C69A32)",
            margin: "0 auto 24px",
            borderRadius: "2px",
          }}
        />

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "12px",
            marginBottom: "16px",
          }}
        >
          <FileText size={28} color="#F2C231" />
          <h1
            style={{
              color: "#F2C231",
              fontSize: "clamp(1.6rem, 4vw, 2.4rem)",
              fontWeight: "700",
              margin: 0,
              letterSpacing: "0.02em",
            }}
          >
            Condizioni Generali di Contratto
          </h1>
        </div>

        <p
          style={{
            color: "#94A3B8",
            fontSize: "0.95rem",
            maxWidth: "560px",
            margin: "0 auto 8px",
            lineHeight: "1.7",
            fontFamily: "'Arial', sans-serif",
          }}
        >
         CAF DIPENDENTI E PENSIONATI AIC SRL — Via Andrea Costa 15, 42017 Novellara (RE)
          <br />
          C.F. 02920400351 &nbsp;·&nbsp;{" "}
          <a
            href="mailto: cafpraticheonline@gmail.com"
            style={{ color: "#F2C231", textDecoration: "none" }}
          >
             cafpraticheonline@gmail.com
          </a>
        </p>

        {/* Gold decorative line bottom */}
        <div
          style={{
            width: "60px",
            height: "3px",
            background: "linear-gradient(90deg, #C69A32, #F2C231)",
            margin: "24px auto 0",
            borderRadius: "2px",
          }}
        />
      </div>

      {/* Intro block */}
      <div
        style={{
          maxWidth: "860px",
          margin: "0 auto",
          padding: "0 24px 32px",
          opacity: visible ? 1 : 0,
          transition: "opacity 0.7s ease 0.2s",
        }}
      >
        <div
          style={{
            background: "rgba(242,194,49,0.05)",
            border: "1px solid rgba(242,194,49,0.2)",
            borderRadius: "12px",
            padding: "24px 28px",
            color: "#94A3B8",
            fontSize: "0.875rem",
            lineHeight: "1.9",
            fontFamily: "'Arial', sans-serif",
          }}
        >
          <strong style={{ color: "#CBD5E1" }}>Premesso</strong> che il
          Venditore gestisce il sito{" "}
          <a
            href="https://cafpraticheonline.it/"
            style={{ color: "#F2C231", textDecoration: "none" }}
            target="_blank"
            rel="noreferrer"
          >
            https://cafpraticheonline.it/
          </a>{" "}
          destinato a transazioni commerciali tra imprenditore e consumatore
          (B2C); che l'acquisto all'interno del sito da parte dei clienti è
          regolato dalle presenti Condizioni Generali di Vendita; che
          l'Acquirente riveste lo status di consumatore, intendendosi per tale
          la persona fisica che compie l'acquisto per scopi non riferibili
          all'attività commerciale o professionale eventualmente svolta; che il
          marchio e il logo relativi al sito sono di esclusiva proprietà del
          Venditore; che le presenti premesse costituiscono parte integrante e
          sostanziale del contratto.
        </div>
      </div>

      {/* Accordion articles */}
      <div
        style={{
          maxWidth: "860px",
          margin: "0 auto",
          padding: "0 24px 80px",
          opacity: visible ? 1 : 0,
          transition: "opacity 0.7s ease 0.35s",
        }}
      >
        <div
          style={{
            background: "rgba(255,255,255,0.03)",
            border: "1px solid rgba(242,194,49,0.15)",
            borderRadius: "16px",
            overflow: "hidden",
            backdropFilter: "blur(6px)",
          }}
        >
          {articles.map((article) => (
            <AccordionItem
              key={article.id}
              article={article}
              isOpen={openArticle === article.id}
              onToggle={() => handleToggle(article.id)}
            />
          ))}
        </div>

        {/* Footer note */}
        <p
          style={{
            textAlign: "center",
            color: "rgba(148,163,184,0.45)",
            fontSize: "0.75rem",
            marginTop: "32px",
            fontFamily: "'Arial', sans-serif",
            letterSpacing: "0.04em",
          }}
        >
          © 2026 CAF DIPENDENTI E PENSIONATI AIC SRL · Tutti i diritti riservati · Regolato dalla legge italiana
        </p>
      </div>
    </div>
  );
};

export default TermsNConditions;